import React, { useState } from 'react';

/*

.dz\:field--invalid {
    color: #a51f18 !important;
    border-color: #a51f18 !important;
}

.dz\:error-message {
    display: none;
    color: #a51f18 !important;
}

.dz\:error--show {
    display: block !important;
}

 */

const FormInput = (props) => {
  const [focused, setFocused] = useState(false);
  const {
    containerStyle,
    name,
    id,
    label,
    hint,
    onChange,
    errorMessage,
    ...inputProps
  } = props;

  const handleFocused = (e) => {
    setFocused(true);
  };

  return (
    <div className={containerStyle}>
      <label htmlFor={name} className='form-label'>
        {label}
      </label>
      <input
        className={`form-control quoter-form-control dz:field--invalid- `}
        name={name}
        {...inputProps}
        onChange={onChange}
        onBlur={handleFocused}
        focused={focused.toString()}
      />
      <div id={`${name}Help`} className='form-text'>
        {hint}
      </div>
      <span className={`dz:error-message dz:error--show-`}>{errorMessage}</span>
    </div>
  );
};

export default FormInput;
